<template>
  <div class="dark:bg-background-dark flex grow justify-center items-center w-screen">
    <div
      v-if="showBackground"
      class="hidden md:block absolute top-0 left-0 right-0 bottom-0 h-screen"
      :style="`background: url(${loginLogoBottom}) right bottom no-repeat, url(${loginLogoTop}) left top no-repeat;`"
    />
    <div
      class="flex w-full content-center items-center z-10 md:mx-3xl justify-center h-mobile-fix min-h-[100dvh]"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { useResponsive, useTheme, extractCssVarName } from '@onereach/ui-components';
import { useCssVar } from '@vueuse/core';
import { computed, onMounted, onBeforeUnmount, defineComponent } from 'vue';

import loginLogoBottom from '@/assets/login-logo-bottom.png';
import loginLogoTop from '@/assets/login-logo-top.png';

export default defineComponent({
  props: {
    background: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { isDesktop } = useResponsive();
    const htmlElement = document.documentElement;
    const theme = useTheme();

    const colorVariable = theme.backgroundColor['background-dark'];
    const backgroundColor = useCssVar(extractCssVarName(colorVariable));

    onMounted(() => {
      htmlElement.setAttribute('data-theme', 'dark');
      const themeColorMeta = document.querySelector('meta[name="theme-color"]');
      themeColorMeta?.setAttribute('content', backgroundColor.value!);
    });

    onBeforeUnmount(() => {
      htmlElement.removeAttribute('data-theme');
    });

    const showBackground = computed(() => props.background && isDesktop);

    return {
      showBackground,
      loginLogoBottom,
      loginLogoTop,
    };
  },
});
</script>
